export default {
  "home": {
    "hero_title": "创意设计，由此开始",
    "hero_subtitle": "黄油网站是专为创意人群打造的内容创作与设计平台，提供丰富的模板、素材与工具，帮助您轻松制作精美图文内容",
    "hero_cta": "立即体验",
    "hero_secondary": "查看模板库",
    "features_title": "为什么选择黄油网站？",
    "features_subtitle": "我们为创作者打造的一站式设计解决方案",
    "template_title": "热门模板推荐",
    "template_subtitle": "精选优质模板，一键套用，快速出图",
    "template_downloads": "次下载",
    "template_new": "新品",
    "template_hot": "热门",
    "article_title": "最新创意文章",
    "article_subtitle": "学习设计技巧，获取创作灵感",
    "article_read_more": "阅读全文",
    "article_read_time": "分钟阅读",
    "cta_title": "准备好开始创作了吗？",
    "cta_subtitle": "立即加入超过100万创作者，在黄油网站释放你的创意潜能",
    "cta_button": "免费开始使用",
    "stats_users": "活跃用户",
    "stats_templates": "设计模板",
    "stats_downloads": "累计下载",
    "stats_satisfaction": "用户满意度"
  },
  "nav": {
    "home": "首页",
    "categories": "分类浏览",
    "templates": "模板素材",
    "tutorials": "使用教程",
    "about": "关于我们",
    "login": "登录",
    "register": "注册"
  },
  "footer": {
    "brand_desc": "黄油网站是领先的创意设计与内容创作平台，致力于为创作者提供最优质的模板、素材和设计工具。",
    "products": "产品服务",
    "templates": "设计模板",
    "assets": "素材库",
    "editor": "在线编辑器",
    "brand_kit": "品牌工具包",
    "support": "帮助支持",
    "help_center": "帮助中心",
    "tutorial": "使用教程",
    "faq": "常见问题",
    "contact": "联系我们",
    "company": "关于我们",
    "about_us": "公司介绍",
    "blog": "官方博客",
    "join_us": "加入我们",
    "partners": "合作伙伴",
    "copyright": "© 2024 黄油网站 HuangYou. All rights reserved.",
    "icp": "ICP备2024000001号"
  },
  "category": {
    "title": "浏览分类",
    "subtitle": "探索不同领域的设计灵感与实用资源",
    "all": "全部",
    "article_count": "篇文章",
    "no_articles": "该分类暂无文章",
    "back_to_categories": "返回分类列表"
  },
  "article": {
    "author": "作者",
    "date": "发布时间",
    "category": "分类",
    "tags": "标签",
    "read_time": "阅读时长",
    "related": "相关文章",
    "back_to_articles": "返回文章列表",
    "share": "分享文章",
    "breadcrumb_home": "首页",
    "breadcrumb_category": "分类",
    "breadcrumb_article": "文章详情"
  },
  "about": {
    "title": "关于黄油网站",
    "subtitle": "让每个人都能轻松创作出精美的设计作品",
    "story_title": "我们的故事",
    "story_content_1": "黄油网站的创立源于一个简单的想法：设计不应该是少数人的特权。每个人都应该有工具来表达自己的创意，无论是否有设计背景。",
    "story_content_2": "自2020年上线以来，黄油网站已经从一个小型模板工具，成长为拥有数百万用户的综合创意设计平台。我们始终坚持产品驱动、用户至上的理念，不断迭代优化产品体验。",
    "story_content_3": "今天，黄油网站服务着来自全球的创作者，涵盖自由设计师、新媒体运营、创业者、学生等多元群体。我们相信，最好的设计工具应该让创意过程变得简单而愉悦。",
    "mission_title": "我们的使命",
    "mission_content": "通过技术降低设计门槛，让每一个有创意的人都能轻松表达自己。",
    "values_title": "核心价值观",
    "value_user_first": "用户至上",
    "value_user_first_desc": "一切产品决策以用户需求为出发点",
    "value_innovation": "持续创新",
    "value_innovation_desc": "不断探索新技术，提升创作体验",
    "value_quality": "品质追求",
    "value_quality_desc": "对每一款模板、每一个素材精益求精",
    "value_open": "开放共享",
    "value_open_desc": "构建开放的创作者生态，共享创意价值",
    "testimonials_title": "用户口碑",
    "testimonials_subtitle": "听听创作者们怎么说",
    "contact_title": "联系我们",
    "contact_subtitle": "有任何问题或建议？我们很乐意倾听",
    "contact_address": "公司地址",
    "contact_email": "电子邮箱",
    "contact_phone": "联系电话",
    "contact_wechat": "微信公众号",
    "contact_form_name": "姓名",
    "contact_form_email": "邮箱",
    "contact_form_subject": "主题",
    "contact_form_message": "留言内容",
    "contact_form_submit": "发送消息",
    "contact_form_success": "感谢您的留言，我们会尽快回复！",
    "contact_form_error": "发送失败，请稍后重试",
    "address_value": "北京市朝阳区建国路88号SOHO现代城A座",
    "email_value": "hello@huangyou.design",
    "phone_value": "400-888-8888",
    "wechat_value": "黄油网站设计助手"
  },
  "seo": {
    "home_title": "黄油网站 - 创意设计与内容创作平台 | 模板下载·素材库·图文制作",
    "home_description": "黄油网站是专为创意人群打造的内容创作与设计平台，提供丰富的模板、素材与工具，帮助用户轻松制作精美图文内容。无论是个人创作还是商业设计，黄油网站都能满足你的创意需求，立即体验高效创作乐趣。",
    "home_keywords": "黄油网站,黄油网站模板下载,黄油网站创意设计,黄油网站图文制作,黄油网站素材库,黄油网站使用教程,黄油网站官方入口",
    "category_title_prefix": "分类",
    "category_description_prefix": "浏览黄油网站",
    "category_keywords_prefix": "黄油网站",
    "article_description_prefix": "阅读黄油网站文章：",
    "article_keywords_prefix": "黄油网站",
    "about_title": "关于我们 - 黄油网站 | 品牌介绍·用户口碑·联系方式",
    "about_description": "了解黄油网站的品牌故事与发展历程，查看用户口碑评价，获取联系方式。黄油网站致力于为创作者提供最优质的创意设计工具与服务。",
    "about_keywords": "黄油网站,关于黄油网站,黄油网站品牌介绍,黄油网站联系方式,黄油网站用户评价"
  }
};